import {
    FETCH_RASPA_CYCLE_HOUR_USAGE_STATISTICS,
    FETCH_RASPA_CYCLES,
    NEW_RASPA_CYCLE,
    NEW_RASPA_CYCLE_SUCCESS, RECEIVE_RASPA_CYCLE_HOUR_USAGE_STATISTICS,
    RECEIVE_RASPA_CYCLES,
    FETCH_RASPAS,
    RECEIVE_RASPAS, RECEIVE_RASPA_REPORT_DATA, FETCH_RASPA_REPORT_DATA
} from "../actions/actionTypes";

const initalState = {
    isFetchingRaspaCycles: false,
    isFetchingRaspaCycleStatistics: false,
    isFetchingRaspaReportData: false,
    Raspas: [],
    RaspaCycles: [],
    RaspaCycleStatistics: {
        hourUsageTotals: [],
        buffingStatsPerSaw: [],
        BuffingStatsPerSawPerOperator: [],
        buffingStatsPerSawPerOperator: [],
        raspaRithmPerOperator: []

    },
    raspaReportData: null
}

export default (state = initalState, action) => {
    switch(action.type) {
        case FETCH_RASPAS:
            return {
                ...state,
                Raspas: []
            }
        case RECEIVE_RASPAS:
            console.log('reducer receive ', action.payload);
            return {
                ...state,
                Raspas: action.payload
            }
            break;
        case FETCH_RASPA_CYCLES:
            return {
                ...state,
                isFetchingRaspaCycles: true
            }
        case RECEIVE_RASPA_CYCLES:
             console.log('reducer receive ', action.payload);
            return {
                ...state,
                isFetchingRaspaCycles: false,
                RaspaCycles: action.payload,

            }
            break;

        case FETCH_RASPA_REPORT_DATA:
            return {
                ...state,
                isFetchingRaspaReportData: true,
                raspaReportData: null

            }
            break;

        case RECEIVE_RASPA_REPORT_DATA:
            console.log('reducer report receive ', action.payload);
            return {
                ...state,
                isFetchingRaspaReportData: false,
                raspaReportData: action.payload
            }
            break;


        case NEW_RASPA_CYCLE:
            return {
                ...state,
                isFetchingRaspaCycles: true
            }
        case NEW_RASPA_CYCLE_SUCCESS:
            let newArray = state.RaspaCycles;
            newArray.push(action.payload);
            return {
                ...state,
                isFetchingRaspaCycles: false,
                RaspaCycles: newArray
            }
        case FETCH_RASPA_CYCLE_HOUR_USAGE_STATISTICS:
            console.log('reducer statistics fetch ', action.payload);
            return {
                ...state,
                isFetchingRaspaCycleStatistics: true,
                RaspaCycleStatistics: action.payload
            }
            break;
        case RECEIVE_RASPA_CYCLE_HOUR_USAGE_STATISTICS:
            console.log('reducer statistics receive ', action.payload);
            return {
                ...state,
                isFetchingRaspaCycleStatistics: false,
                RaspaCycleStatistics: action.payload
            }
            break;
        default:
            return state;
    }
}
